/**
 * Created by Administrador on 11/25/2016.
 */
(function(){
    'use strict';

    var timePickerCopy = {
        template: '',
        controller: timePickerCopyController,
        controllerAs: 'vm',
        bindings: {
            indexX: '=',
            indexY: '=',
            indexSize: '=',
            segment: '=',
            flightTimes: '=',
            itineraryFlight: '=',
            form: '=',
            onEventChange: '&'
        }
    }

    timePickerCopyController.$inject = ['$element', '$timeout'];

    function timePickerCopyController($element, $timeout) {
        var vm = this;

        vm.$onInit = function () {
            vm.eleJQInput = $element.parent().find('.bootstrap-timepicker > .form-control');
            vm.$postLink();
        }

        vm.$postLink = function() {
            vm.eleJQInput.on('change', function(){
                vm.element = $(this);
                vm.nameKey = vm.segment.replace(/[-() ]/g, "_");

                $timeout(function () {
                    vm.newTimeKey = "0:00";

                    if(vm.flightTimes[vm.nameKey] !== undefined){
                        vm.newTimeKey = vm.flightTimes[vm.nameKey].time;
                    }

                    vm.newTime = sumTime(vm.element.val(), vm.newTimeKey);
                    vm.itineraryFlight.departures[vm.indexX].stretchRoutes[vm.indexY].arrivalTime = vm.newTime;

                    for(var i = vm.indexY + 1; i < vm.indexSize; i++){
                        var eleDepartureTime = $("#departureTime_" + vm.indexX + "_" + i),
                            eleSegment = eleDepartureTime.attr('data-segment'),
                            eleKey = eleSegment.replace(/[-() ]/g, "_"),
                            timeKey = "0:00";

                        if(vm.flightTimes[eleKey] !== undefined){
                            timeKey = vm.flightTimes[eleKey].time;
                        }

                        var newTimeCurrent = vm.itineraryFlight.departures[vm.indexX].stretchRoutes[i-1].arrivalTime,
                            eleTime = sumTime(newTimeCurrent, timeKey);

                        vm.itineraryFlight.departures[vm.indexX].stretchRoutes[i].departureTime = newTimeCurrent;
                        vm.itineraryFlight.departures[vm.indexX].stretchRoutes[i].arrivalTime = eleTime;
                    }
                });
            });
        }
    }

    function sumTime(timeCurrent, timeAux){
        if(timeCurrent.indexOf(":") > -1){
            var timeCurrentSplit = timeCurrent.split(":"),
                timeAuxSplit = timeAux.split(":");

            var sumMinutes = parseInt(timeCurrentSplit[1]) + parseInt(timeAuxSplit[1]),
                sumHour = parseInt(timeCurrentSplit[0]) + parseInt(timeAuxSplit[0]);

            if(sumMinutes >= 60){
                sumHour = sumHour + 1;
                sumMinutes = sumMinutes - 60;
            }

            if(sumHour >= 24){
                sumHour = sumHour - 24;
            }

            if(sumHour < 10){
                // sumHour = "0" + sumHour;
            }

            if(sumMinutes < 10){
                sumMinutes = "0" + sumMinutes;
            }
        }
        return sumHour + ":" + sumMinutes;
    }

    angular
        .module('completeAir')
        .component('timePickerCopy', timePickerCopy);
})();
